export const secondsToMinutes = (totalSeconds) => {
  const remainSec = totalSeconds % 60;
  let totalMinutes = Math.floor(totalSeconds / 60);
  if (remainSec > 30) totalMinutes += 1;
  return totalMinutes;
};

export const minutesToDisplay = (totalMinutes) => {
  if (totalMinutes == null) return '-';
  if (totalMinutes <= 0) return '0분';
  const totalSeconds = Math.round(totalMinutes * 60);
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const parts = [];
  if (h > 0) parts.push(`${h}시간`);
  if (m > 0) parts.push(`${m}분`);
  if (s > 0) parts.push(`${s}초`);
  return parts.join(' ') || '0분';
};

export const secondsToDisplay = (totalSeconds) => {
  if (totalSeconds == null || totalSeconds <= 0) return '0초';
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  const parts = [];
  if (h > 0) parts.push(`${h}시간`);
  if (m > 0) parts.push(`${m}분`);
  if (s > 0) parts.push(`${s}초`);
  return parts.join(' ') || '0초';
};
